import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { Cancel as CancelIcon } from '@material-ui/icons';

const ButtonCancel = ({
  onClick, className, style,
}) => (
  <Button
    className={className}
    style={style}
    variant="outlined"
    onClick={onClick}
    startIcon={<CancelIcon />}
  >
    Cancelar
  </Button>
);

ButtonCancel.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.shape(),
};

ButtonCancel.defaultProps = {
  className: '',
  style: {},
};

export default ButtonCancel;
